import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Research.css";
import ResearchBanner from "../../Images/research/Research.png";
import DerivativeStratergy from "../../Images/research/DerivativeStratergy.png";
import StartImg from "../../Images/start-trading.png";
import MorningNote from "../../Images//research/morning-note.png";
import ResultUpdates from "../../Images//research/ResultUpdates.png";
import EconomyUpdates from "../../Images//research/EconomyUpdates.png";
import IPOCoverage from "../../Images//research/IPOCoverage.png";
import CompanyReport from "../../Images//research/CompanyReport.png";
import MonthlyMagzines from "../../Images//research/MonthlyMagzines.png";
import MarginReport from "../../Images//research/MarginReport.png";
import MetalsEnergyWatch from "../../Images//research/MetalsEnergyWatch.png";
import Blog from "../../Images//research/blog.png";
import Learning from '../Home/learning/Learning';
import CallTrackApi from "../Activity_Track/CallTrackApi";
function Research() {
    const [CategoryData, setCatData] = useState([]);
    const imageUrl = [MorningNote, DerivativeStratergy, ResultUpdates, EconomyUpdates, IPOCoverage, CompanyReport, MonthlyMagzines, MetalsEnergyWatch, MarginReport]
    useEffect(() => {
        SelectCategory()
    }, [])
    const SelectCategory = () => {
        const request = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            //body: JSON.stringify({'ctg':category,'title':title_name,'desp':data,'post_title':post_title,'meta_desp':meta_desp,'meta_key':meta_keyword,'title_catg':title})    
        }
        fetch('https://moneysukh.com:8443/selCatg', request)
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        //console.log(json)
                        if (json.results.length > 0) {
                            setCatData(json.results)
                        }
                        // showToast(" Successful Added", "success");

                    })
                }
            })
            .catch(e => {
                //console.log(e);
            })
    }
  CallTrackApi("Research",window.location.href);
    return (
        <>
            <section className="researchbanner_section">
                <Container>
                    <Row className="align-items-center">
                        <Col xl={7} md={7} sm={12}>
                            <div className="commoninnerhero_text">
                                <h2>Research</h2>
                                <div class="blutext">WELCOME TO MONEYSUKH RESEARCH </div>
                                <p>At Moneysukh we understand that every investor's needs and goals are different.
                                    Hence we provide a comprehensive set of research reports, so that you can make the
                                    right investment decisions regardless of your investing preferences!
                                </p>
                            </div>
                        </Col>
                        <Col xl={5} md={5} sm={12}>
                            <div className="researchbanner_imgpanel text-right">
                                <img src={ResearchBanner} alt={ResearchBanner} className="img-fluid" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="researchcat_section">
                <Container>
                    <div className="researchcat_main">
                        <div className="researchcat_grid">
                            <Row className="align-items-center">
                                {CategoryData && CategoryData.map((row, index) => {
                                    return (<Col xl={4} md={4} sm={6} xs={12}>
                                        <div className="researchcat_group" key={index}>
                                            <div className="researchcat_panel">
                                                <a href={(row.add_catg != "Margin Reports") ? "/Research/" + row.add_url : "/Research/margin-report"}>
                                                    <img src={imageUrl[index]} alt={imageUrl[index]} className="img-fluid mx-auto d-block" />
                                                    <h2>{row.add_catg}</h2>
                                                </a>
                                            </div>
                                        </div>
                                    </Col>)
                                })}
                                {/* <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                        <a >
                                            <img src={ResultUpdates} alt={ResultUpdates} className="img-fluid mx-auto d-block" />
                                            <h2>Result Updates</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                        <a >
                                            <img src={EconomyUpdates} alt={EconomyUpdates} className="img-fluid mx-auto d-block" />
                                            <h2>Economy Updates</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                        <a>
                                            <img src={IPOCoverage} alt={IPOCoverage} className="img-fluid mx-auto d-block" />
                                            <h2>IPO Coverage</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                        <a >
                                            <img src={CompanyReport} alt={CompanyReport} className="img-fluid mx-auto d-block" />
                                            <h2>Company Reports</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                        <a >
                                            <img src={MonthlyMagzines} alt={MonthlyMagzines} className="img-fluid mx-auto d-block" />
                                            <h2>Monthly Magzines</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                            <a >
                                            <img src={DerivativeStratergy} alt={DerivativeStratergy} className="img-fluid mx-auto d-block" />
                                            <h2>Derivative stratergy</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                            <a >
                                            <img src={MarginReport} alt={MarginReport} className="img-fluid mx-auto d-block" />
                                            <h2>Margin Report</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={4} md={4} sm={6} xs={12}>
                                    <div className="researchcat_group">
                                        <div className="researchcat_panel">
                                            <a >
                                            <img src={MetalsEnergyWatch} alt={MetalsEnergyWatch} className="img-fluid mx-auto d-block" />
                                            <h2>Metals and Energy Watch</h2>
                                            </a>
                                        </div>
                                    </div>
                                </Col> */}

                            </Row>
                        </div>
                    </div>

                </Container>
            </section>
            <Learning />
            {/* <section className="start-market">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <img
                                className="img-fluid start-trading-img"
                                src={StartImg}
                                alt="StartImg"
                            />
                        </Col>
                        <Col md={6}>
                            <h2>
                                Start trading & profiting
                <br /> right away!
              </h2>
                            <p>We won't let your Ledger Balance sit idle.</p>
                            {// <button>Sign Up</button> }
                        </Col>
                    </Row>
                </Container>
            </section> */}

            {/* <section className="dial-contact-sc">
               <Container>
                    <Row>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                            <div className="contact-common-pnl contact-left-pnl">
                                <h2>Timings</h2>
                                <ul>
                                    <li>Equities & Derivatives: 8:30 AM to 4:30 PM</li>
                                    <li>Currency: 9 AM to 5 PM</li>
                                    <li>Commodity: 9 AM till market close</li>
                                </ul>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                            <div className="contact-common-pnl contact-center-pnl">
                                <h2>Contact</h2>
                                <p>9638236000</p>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                            <div className="contact-common-pnl contact-right-pnl">
                                <h2>3 Steps Only</h2>
                                <ul>
                                    <li>Dial 9638236000</li>
                                    <li>Enter IVR Login ID & IVR TPIN (sent via SMS/email during account opening)</li>
                                    <li>Select segment</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
               </Container>
            </section>    */}
        </>
    )
}

export default Research;